var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-client-picker" },
    [
      _vm.label
        ? _c(
            "span",
            { staticClass: "az-text-small text-color-600 mb-1 d-block" },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e(),
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            "offset-y": "",
            "min-width": "280",
            "max-width": "300",
            transition: "scale-transition",
            "content-class": "task-client-picker__menu"
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "button",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass:
                            "task-client-picker__trigger d-inline-flex align-center",
                          class: {
                            "task-client-picker__trigger--empty": !_vm.hasSelection
                          },
                          attrs: {
                            type: "button",
                            disabled: _vm.disabled,
                            "aria-label": _vm.hasSelection
                              ? "Alterar cliente vinculado"
                              : "Vincular cliente",
                            title: _vm.hasSelection ? null : _vm.placeholder
                          }
                        },
                        "button",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      !_vm.hasSelection
                        ? [
                            _c("icon-svg", {
                              attrs: {
                                name: "mdi-domain",
                                size: 16,
                                color: "var(--secondary)"
                              }
                            }),
                            !_vm.iconOnly
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "az-text-small text-color-400 ml-1"
                                  },
                                  [_vm._v(_vm._s(_vm.placeholder))]
                                )
                              : _vm._e()
                          ]
                        : _vm.decoratedValue
                        ? [
                            _c(
                              "span",
                              {
                                staticClass: "task-client-picker__avatar",
                                style: {
                                  backgroundColor: _vm.decoratedValue.bgColor,
                                  color: _vm.decoratedValue.textColor
                                },
                                attrs: { title: _vm.decoratedValue.nome }
                              },
                              [
                                _vm.decoratedValue.avatar
                                  ? _c("img", {
                                      staticClass:
                                        "task-client-picker__avatar-img",
                                      attrs: {
                                        src: _vm.decoratedValue.avatar,
                                        alt: _vm.decoratedValue.initials
                                      }
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.decoratedValue.initials)
                                      )
                                    ])
                              ]
                            ),
                            _vm.showName
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "az-text-small text-color-800 ml-2 text-truncate"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.decoratedValue.nome) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.menuOpen,
            callback: function($$v) {
              _vm.menuOpen = $$v
            },
            expression: "menuOpen"
          }
        },
        [
          _vm.menuOpen
            ? _c(
                "div",
                { staticClass: "task-client-picker__dropdown pa-2" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "px-2 py-1 az-text-small font-weight-bold text-color-500"
                    },
                    [_vm._v("Cliente vinculado")]
                  ),
                  _c(
                    "div",
                    { staticClass: "mb-2 px-1" },
                    [
                      _c("InputByType", {
                        staticClass: "new-ux",
                        attrs: {
                          type: "search",
                          label: "",
                          placeholder: "Buscar...",
                          outlined: "",
                          dense: "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.loading
                    ? _c("v-progress-linear", {
                        staticClass: "mb-2",
                        attrs: { indeterminate: "", height: "2" }
                      })
                    : _vm._e(),
                  _vm.hasSelection && (!_vm.search || !_vm.search.length)
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "task-client-picker__option task-client-picker__option--clear d-flex align-center",
                          on: { click: _vm.clearSelection }
                        },
                        [
                          _c("icon-svg", {
                            staticClass: "mr-2",
                            attrs: {
                              name: "mdi-close-circle-outline",
                              size: 18,
                              color: "var(--secondary)"
                            }
                          }),
                          _c(
                            "span",
                            { staticClass: "az-text-small text-color-700" },
                            [_vm._v("Remover vínculo")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.loading && _vm.filteredClients.length === 0
                    ? _c("div", { staticClass: "pa-3 text-center" }, [
                        _c(
                          "span",
                          { staticClass: "az-text-small text-color-400" },
                          [_vm._v("Nenhum cliente encontrado")]
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "task-client-picker__list",
                      on: { scroll: _vm.onListScroll }
                    },
                    _vm._l(_vm.visibleClients, function(client) {
                      return _c(
                        "div",
                        {
                          key: "client-" + client.id,
                          staticClass:
                            "task-client-picker__option d-flex align-center",
                          class: {
                            "task-client-picker__option--selected":
                              client.id === _vm.selectedId
                          },
                          on: {
                            click: function($event) {
                              return _vm.pickClient(client.raw)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "task-client-picker__avatar mr-2",
                              style: {
                                backgroundColor: client.bgColor,
                                color: client.textColor
                              }
                            },
                            [
                              client.avatar
                                ? _c("img", {
                                    staticClass:
                                      "task-client-picker__avatar-img",
                                    attrs: {
                                      src: client.avatar,
                                      alt: client.initials
                                    }
                                  })
                                : _c("span", [_vm._v(_vm._s(client.initials))])
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "az-text-small flex-grow-1 text-color-800 text-truncate"
                            },
                            [_vm._v(" " + _vm._s(client.nome) + " ")]
                          ),
                          client.id === _vm.selectedId
                            ? _c("icon-svg", {
                                attrs: {
                                  name: "mdi-check",
                                  size: 16,
                                  color: "var(--primary)"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }